// Personal-detail fields a driver can self-complete from the portal. These map to
// the Drivers sheet via the existing updateDriver action (same keys the Personnel
// profile uses). Company Name is deliberately excluded — the entity is set up later.
export const DETAIL_FIELDS = [
  { key: 'name',        label: 'Full legal name',     type: 'text',  placeholder: 'As on your ID' },
  { key: 'address',     label: 'Residential address', type: 'text',  placeholder: 'Street, suburb, state, postcode' },
  { key: 'phone',       label: 'Mobile number',       type: 'tel',   placeholder: '04…' },
  { key: 'email',       label: 'Email',               type: 'email', placeholder: 'you@example.com' },
  { key: 'abn',         label: 'ABN',                 type: 'text',  placeholder: '11 digits' },
  { key: 'accountName', label: 'Bank account name',   type: 'text',  placeholder: 'Name on the account' },
  { key: 'bsb',         label: 'BSB',                 type: 'text',  placeholder: '6 digits' },
  { key: 'accNumber',   label: 'Account number',      type: 'text',  placeholder: 'Account number' },
];

export const DETAIL_LABEL = Object.fromEntries(DETAIL_FIELDS.map(f => [f.key, f.label]));

// Which of the above are blank on a driver record (so we only ask for what's missing).
export function missingDetailKeys(driver) {
  return DETAIL_FIELDS
    .filter(f => !((driver?.[f.key] ?? '').toString().trim()))
    .map(f => f.key);
}
